import { Card, Input, Select } from '@bancobarigui/barihaus';
import { FileTextOutlined } from '@ant-design/icons';
import { PageSectionHeader, FormField } from '../shared/components';

export interface InspectionType {
  value: string;
  label: string;
  disabled?: boolean;
}

interface ChecklistDataSectionProps {
  name: string;
  setName: (value: string) => void;
  selectedInspectionType: string | undefined;
  setSelectedInspectionType: (value: string | undefined) => void;
  inspectionTypes: InspectionType[];
  loadingInspectionTypes?: boolean;
}

export function ChecklistDataSection({
  name,
  setName,
  selectedInspectionType,
  setSelectedInspectionType,
  inspectionTypes,
  loadingInspectionTypes = false,
}: ChecklistDataSectionProps) {
  return (
    <Card>
      <PageSectionHeader
        icon={<FileTextOutlined />}
        title="Dados do Checklist"
        description="Preencha os campos abaixo com as informações do checklist."
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField label="Nome" required>
          <Input
            placeholder="Nome do checklist"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </FormField>

        <FormField label="Tipo de Inspeção" required>
          <Select
            placeholder="Selecione um tipo de inspeção"
            options={inspectionTypes as any}
            value={selectedInspectionType as any}
            onChange={setSelectedInspectionType}
            onClear={() => setSelectedInspectionType(undefined)}
            className="w-full"
            showSearch
            allowClear
            loading={loadingInspectionTypes}
          />
        </FormField>
      </div>
    </Card>
  );
}
